import { Store } from '@ngrx/store';

/**
 * Reset Pending Encounter State
 * @param store 
 */
export function resetEncounterStore(store: Store<any>) {
  // reset encounter
  const type1: string = 'ENC_NEW_RESET';
  store.dispatch({ type: type1 });

  // reset chart
  const type2: string = 'CHART_NEW_RESET';
  store.dispatch({ type: type2 });

  // reset prescription
  const type3: string = 'PRESC_NEW_RESET';
  store.dispatch({ type: type3 });

  // reset form
  const type4: string = 'FORM_NEW_RESET';
  store.dispatch({ type: type4 });

  // reset diagnostic
  const type5: string = 'DIAG_TEST_NEW_RESET';
  store.dispatch({ type: type5 });
  const type6: string = 'DIAG_NEW_RESET';
  store.dispatch({ type: type6 });

  // reset growth chart
  const type7: string = 'GC_NEW_RESET';
  store.dispatch({ type: type7 });

  // reset vaccination
  const type8: string = 'VC_NEW_RESET';
  store.dispatch({ type: type8 });

  // reset ros
  const type9: string = 'ROS_NEW_RESET';
  store.dispatch({ type: type9 });

  // reset shx
  const type10: string = 'SOCHX_NEW_RESET';
  store.dispatch({ type: type10 });

  // reset medhx
  const type11: string = 'MEDHX_NEW_RESET';
  store.dispatch({ type: type11 });

  // reset fhx
  const type12: string = 'FAMHX_NEW_RESET';
  store.dispatch({ type: type12 });

  const newMedicalRecordTypes: string[] = ['ATTACHMENTS_NEW_RESET', 'CARE_PLAN_NEW_RESET',
    'CHIEF_COMPLAINT_NEW_RESET', 'DIAGNOSIS_NEW_RESET', 'DIAGNOSTIC_ORDER_NEW_RESET',
    'HISTORY_FMHX_NEW_RESET', 'IMPRESSION_NEW_RESET', 'HISTORY_PMHX_NEW_RESET', 
    'PRESCRIPTION_NEW_RESET', 'PROCEDURE_NEW_RESET', 'HISTORY_ROS_NEW_RESET', 'HISTORY_SOCHX_NEW_RESET',
    'VITALS_NEW_RESET'];
  newMedicalRecordTypes.map(val => { store.dispatch({ type: val }); return val});
}

export function resetCurrentQueue(store: Store<any>) {
  // reset encounter
  const type: string = 'Q_CURRENT_RESET';
  store.dispatch({ type });
}